import { render } from "./LegItinerary.vue?vue&type=template&id=6f3cf5ba&scoped=true&lang=pug"
import script from "./LegItinerary.vue?vue&type=script&lang=ts"
export * from "./LegItinerary.vue?vue&type=script&lang=ts"

import "./LegItinerary.vue?vue&type=style&index=0&id=6f3cf5ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f3cf5ba"

export default script